/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { AboutInfoModule } from './about-info/about-info.module';
import { HelpMemuComponent } from './help-memu.component';
import { HelpMenuStrService } from './help-menu-str.service';
import { intelligentCustomerServiceModule } from './intelligent-customer-service/intelligent-customer-service.module';

@NgModule({
    declarations: [HelpMemuComponent],
    imports: [
        CommonModule,
        CoreModule,
        AboutInfoModule,
        intelligentCustomerServiceModule,
    ],
    providers: [
        HelpMenuStrService,
    ],
    exports: [HelpMemuComponent],
})
export class HelpMemuModule { }
